import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Button, OverlayTrigger, Panel, Popover } from 'react-bootstrap'

import FormField from '../FormField'
import Icon from '../../Icon'
import LockingPasswordField from '../LockingPasswordField'
import withPasswordStrength from '../../../containers/Form/withPasswordStrength'

import Data from './Data'
import Meter from './Meter'
import Suggestions from './Suggestions'

export function Password({
  bsSize,
  children,
  controlId,
  controlLabel,
  errorKey = controlId,
  errors,
  hasPassword = false,
  placeholder,
  required = false,
  setPassword,
  showRevealPassword = false,
  strength,
  value,
}) {
  const hasErrors = (errors && errors.has(errorKey)) && errors.get(errorKey).size > 0
  const showStrength = !hasErrors && strength
  const validationLevels = ['error', 'error', 'error', 'warning', 'success']

  return (
    <FormField
      bsSize={bsSize}
      controlId={controlId}
      controlLabel={controlLabel}
      errorKey={errorKey}
      errors={errors}
      feedback={false}
      required={required}
      validationState={(strength && !hasErrors) ? validationLevels[strength.score] : undefined}
      value={hasPassword ? true : value}
    >
      <LockingPasswordField
        bsSize={bsSize}
        hasPassword={hasPassword}
        placeholder={placeholder}
        required={required}
        setPassword={setPassword}
        showRevealPassword={showRevealPassword}
        value={value}
      />

      {showStrength && (
        <Meter result={strength} />
      )}

      {showStrength && (
        <Panel>
          <Panel.Body>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="right"
              overlay={<Popover id={`${controlId}-password-strength`}>
                <Data result={strength} />
              </Popover>}
            >
              <Button bsSize="xs" className="pull-right">
                <Icon name="question" fixedWidth />
              </Button>
            </OverlayTrigger>

            <Suggestions
              feedback={strength.feedback}
              score={strength.score}
            />
          </Panel.Body>
        </Panel>
      )}

      {children}
    </FormField>
  )
}

Password.propTypes = {
  bsSize: Pt.string,
  children: Pt.node,
  controlId: Pt.string.isRequired,
  controlLabel: Pt.string.isRequired,
  errorKey: Pt.string,
  errors: Ipt.map,
  hasPassword: Pt.bool,
  placeholder: Pt.string,
  required: Pt.bool,
  setPassword: Pt.func.isRequired,
  showRevealPassword: Pt.bool,
  // eslint-disable-next-line react/forbid-prop-types
  strength: Pt.object,
  value: Pt.string.isRequired,
}

export default withPasswordStrength(Password)



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/Password/index.jsx